import { createSelector } from '@reduxjs/toolkit';
import { resourceSelectors } from '../../utils/resourceSelectors';

export const [
  expertInputDocumentsAllIds,
  expertInputDocumentsById,
  expertInputDocumentsSelector,
] = resourceSelectors('expertInputDocuments');

export const expertInputDocumentsByExpertInputIdSelector = (id) =>
  createSelector(expertInputDocumentsSelector, (documents) =>
    documents.filter((document) => document.expertInput.id === id)
  );
